export default class CartLimitError extends Error {}
